import { isChunkLoadError, handleChunkError } from './chunkErrorHandler'

/**
 * Intercepta promise rejections de chunk load que escapam dos handlers
 * de rota (LazyLoad.js / router.onError). CSS chunks carregados pelo
 * mini-css-extract-plugin podem criar rejections "órfãs" que atingem
 * window.onunhandledrejection antes de qualquer catch na cadeia de
 * import(). Sem este handler, Sentry captura 100+ eventos redundantes.
 *
 * Fixes AAWZ-WEB-2DS
 */
export function installChunkErrorGlobalHandler() {
  if (typeof globalThis === 'undefined' || !globalThis.window) return
  globalThis.addEventListener('unhandledrejection', function onChunkReject(event) {
    if (!event || !event.reason) return
    if (!isChunkLoadError(event.reason)) return
    event.preventDefault()
    handleChunkError()
  })
}

/**
 * Verifica se um Sentry event representa um erro de chunk load para
 * filtrar no beforeSend. Safety net caso o handler global não consiga
 * interceptar (ex.: race condition no registro de listeners).
 *
 * Fixes AAWZ-WEB-2DS
 */
export function isSentryChunkLoadError(event) {
  if (!event || !event.exception || !event.exception.values) return false

  const values = event.exception.values
  for (const exc of values) {
    if (!exc) continue
    if (exc.type === 'ChunkLoadError') return true
    if (
      typeof exc.value === 'string' &&
      /Loading (CSS )?chunk .+ failed/.test(exc.value)
    ) {
      return true
    }
  }

  return false
}
